/**
 * @file    cells.tsx
 * @scope   VIEW
 * @summary Presentational cell variants of DynamicTable (enterprise, link, bar, plain).
 * @consumes SingleHorizontalBarChart, DynamicTableUtils
 * @produces EnterpriseCell, LinkCell, BarCell, PlainCell
 * @sideEffects None — clicks are delegated through props.
 */
import React from 'react';
import SingleHorizontalBarChart from 'components/Charts/SingleHorizontalBarChart/SingleHorizontalBarChart';
import { getIsPercentageFromRow } from '../../common/utils/DynamicTableUtils';

const rowTypeClass = (row: any) =>
  `${row['rowType'] === 'L1' ? 'l1-row' : ''} ${row['rowType'] === 'L2' ? 'l2-row' : ''}`;

export const EnterpriseCell: React.FC<{
  row: any;
  col: any;
  value: any;
  indicator?: React.ReactNode;
}> = ({ row, col, value, indicator }) => (
  <div className="pck-enterprise-cell">
    <div className={rowTypeClass(row)} title={value}>
      <span title={value}>
        {col.isPercentage || getIsPercentageFromRow(row, col.field) ? value + '%' : value}
      </span>
    </div>
    {indicator}
  </div>
);

export const LinkCell: React.FC<{ value: any; onClick: () => void }> = ({ value, onClick }) => (
  <div className="dynamic-table-link">
    <span onClick={onClick} data-tag="allowRowEvents" title={value}>
      {value}
    </span>
  </div>
);

export const BarCell: React.FC<{ value: any }> = ({ value }) => (
  <div className="single-horizontal-bar-chart">
    <SingleHorizontalBarChart
      value={value}
      isPercentage
      color="#0071c1"
      showLabel={true}
      height={20}
      width={200}
    />
  </div>
);

export const PlainCell: React.FC<{ value: any; isPercentage?: boolean }> = ({
  value,
  isPercentage,
}) => <div>{isPercentage ? value + '%' : value}</div>;
